import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const McoClaimLineList = ({ mcoClaim }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!mcoClaim) return;

    rowsReq.partition = mcoClaim.partition;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('mcoClaimId', mcoClaim.id));
  }, [mcoClaim?.partition, mcoClaim?.id]);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons); // Utlization Lines come from system only
  }

  return (
    <EntityList entity="MCO_CLAIM_LINE" augRowsReq={augRowsReq} augTabButtons={augTabButtons} />
  )
}
